export const LISTICON = `<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title> Icon - βeta / System Controls / Grid-L / 1 - 24 / 1 - Gray</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Map-iteration" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="v5" transform="translate(-174.000000, -363.000000)" stroke="currentColor">
            <g id="Group-3">
                <g id="::-TB---Tools" transform="translate(163.000000, 272.000000)">
                    <g id="Group-9" transform="translate(0.000000, 80.000000)">
                        <g id="Group-8">
                            <g id="Tab-Navigation--βeta-/-1---Horizontal-/-1---Default-" transform="translate(8.000000, 8.000000)">
                                <g id="-Icon---βeta-/-System-Controls-/-Grid-L-/-1---24-/-1---Gray">
                                    <g id="Grid-L" transform="translate(3.000000, 3.000000)">
                                        <polygon id="Stroke-340" stroke-width="1.5" points="0.923 7.077 7.076 7.077 7.076 0.923 0.923 0.923"></polygon>
                                        <polygon id="Stroke-341" stroke-width="1.5" points="10.923 7.077 17.077 7.077 17.077 0.923 10.923 0.923"></polygon>
                                        <polygon id="Stroke-354" stroke-width="1.5" points="0.923 17.077 7.076 17.077 7.076 10.923 0.923 10.923"></polygon>
                                        <polygon id="Stroke-355" stroke-width="1.5" points="10.923 17.077 17.077 17.077 17.077 10.923 10.923 10.923"></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export const MAPICON = `<svg width="18" height="18" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="evenodd">
    <path stroke-linecap="round" stroke-linejoin="round" d="M12.52 9.77l2.1 4.18-3.67-1.04L4.66 15 1 13.95l2.1-4.18" fill="none"></path>
    <path d="M4.98 6.46a3.44 3.44 0 0 1 .37-4.43l.02-.02a3.44 3.44 0 0 1 4.87 0l.02.02a3.44 3.44 0 0 1 .37 4.43l-2.82 3.96-2.83-3.96z" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M8.78 4.46a.97.97 0 1 1-1.95 0 .97.97 0 0 1 1.95 0" stroke="none" fill="currentColor"></path>
    </g>
</svg>`;


// WEBPACK FOOTER //
// ./src/universal/components/svg-def/map-tabs.js